import './App.css';
import Home from './components/ConsolaUsuarios/Home';

import { useEffect } from 'react';
function App() {
 

  return (
    <div className="App">
       <Home/>
    </div>
  )
}

export default App;
